module.exports = __webpack_public_path__ + "img/t2-13.e250334b.svg";